import "twin.macro";
import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import PortfolioCard from "../Card/PortfolioCard";

const ListofPortfolio = () => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allPortfolioJson {
        nodes {
          title
          content
          link
          paymentlink
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
          listofImage {
            childImageSharp {
              gatsbyImageData(quality: 100, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `);
  return (
    <div tw="text-white mx-auto max-w-7xl space-y-4 p-5">
      <p tw=" text-center font-black text-3xl">List of Portfolio</p>

      <div tw="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.allPortfolioJson.nodes.map((item, index) => (
          <PortfolioCard {...item} key={index} />
        ))}
      </div>
    </div>
  );
};

export default ListofPortfolio;
